import GlobalMenuButton from './global-menu-button';
import CamContextSwitcher from '../cam-context-switcher/scripts/cam-context-switcher';
import CamContextSwitcherPanel from '../cam-context-switcher/scripts/cam-context-switcher-panel';
import { eventContextChanged } from '../cam-context-switcher/scripts/cam-context-switcher-constants';
import '../cam-context-switcher/styles/main.less';
import camContextSwitcherDatastore from '../cam-context-switcher/scripts/cam-context-switcher-datastore';

export default class GlobalContextSwitcherButton extends GlobalMenuButton {

  render(template, defaultOptions) {
    super.render(template, defaultOptions);

    this.contextChanged();

    let subtitleElement = this.element.querySelector('.dt-gnm-menu-button__current_option');
    subtitleElement.classList.add('context-switcher');

    let selectedContext = {};
    if(defaultOptions.camContext && defaultOptions.camContext.id && defaultOptions.camContext.type) {
      // This comes from query parameters in the URL.
      selectedContext = {
        id: defaultOptions.camContext.id,
        type: defaultOptions.camContext.type
      };
    } else if(this.selectedContextId && this.selectedContextType){
      // This comes from props on the cam-context-switcher element.
      selectedContext = {
        id: this.selectedContextId,
        type: this.selectedContextType
      };
    }

    let camContextSwitcher = new CamContextSwitcher(selectedContext);
    subtitleElement.appendChild(camContextSwitcher);
  }

  observe() {
    super.observe();
    document.addEventListener(eventContextChanged, this.close.bind(this));
    document.addEventListener(eventContextChanged, this.contextChanged.bind(this));
  }

  destroy() {
    super.destroy();
    document.removeEventListener(eventContextChanged, this.close.bind(this));
    document.removeEventListener(eventContextChanged, this.contextChanged.bind(this));
  }

  contextChanged() {
    let titleElement = this.element.querySelector('.dt-gnm-menu-button__title');
    titleElement.textContent = camContextSwitcherDatastore.selectedContext.display.typeName;
  }

  get cssClass() {
    return 'global-context-switcher';
  }

  get menuItems() {
    return [
      new CamContextSwitcherPanel()
    ];
  }

}



// WEBPACK FOOTER //
// ./src/scripts/global-context-switcher-button.js